import DialpadComponent from './Dialpad.component';

export default DialpadComponent;
